import DashboardAlerts from "@system/config/dashboard-alerts";
import ResponseMaker from "./AlertAPICall/responseMaker";
import liveAuth from "../helper/liveAuth";
import Api from "./APIHandler";
import { __remove, __set } from "../store/axios_indicator";

const API = new Api({});

class AlertAPICall {
    alertListByType = async (params = {}) => {
        if (!liveAuth.check()) {
            return await new ResponseMaker({}).process().run().get();
        }
        let res = {};
        let param = {}
        param.data = params
        await API.post(DashboardAlerts.ALERT_LIST_BY_TYPE, param).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data.data
            }
        });
        if(params.pageSize === 0){
            return res;
        } else {
            let result = await new ResponseMaker(res);
            result = await result.process();
            return result.run().get();
        }
    };
    stockAlertList = async (params = {}) => {
        let res = {};
        let param = {}
        param.data = params
        await API.post(DashboardAlerts.STOCK_ALERTS_LIST, param).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data
            }
        });

        return res;
    };
    getStockAlertProducts = async (params = {}) => {
        let res = {};
        let param = {}
        param.data = {stockAlertPartDetails:params}
        await API.post(DashboardAlerts.STOCK_ALERTS_PRODUCTS, param).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data
            }
        });

        return res;
    };
    deleteStockAlert = async (stockAlertId) => {
        let res = {};
        await API.delete(DashboardAlerts.DELETE_STOCK_ALERT + '?stockAlertId=' + stockAlertId).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data
            }
        }).catch((err) => {
            res = err
        });
        return res;
    };
    getStockManufacturers = async () => {
        let res = {};
        await API.get(DashboardAlerts.GET_ALERT_MANUFACTURER).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data.data
            }
        }).catch((err) => {
            res = err
        });
        return res;
    };

    exportData = async (params = {}) => {
        let res = {};
        let param = {};
        param.data = params
        param.data.responseType = "blob"
        __set('EXPORT_ALERT_API_CALL');
        await API.post(DashboardAlerts.ALERT_PCN_EXPORT, param).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data
            }
        });
        __remove('EXPORT_ALERT_API_CALL');
        return res
    }
    exportStockAlertData = async (params = {}) => {
        let res = {};
        let param = {};
        param.data = params
        param.data.responseType = "blob"
        await API.post(DashboardAlerts.EXPORT_STOCK_ALERTS, param).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data
            }
        });
        return res
    }
}

export default AlertAPICall;